import { batchJob } from 'ducks/entities/schema'

export const batchJobsApiV1ResponseSchema = {
  jobs: [batchJob],
}
